import classNames from 'clsx';
import React from 'react';

import type WithChildren from '@swf/core/types/WithChildren';

import styles from './RawInput.scss';
import type { Props } from './Toggle';

export type ToggleGroupProps = WithChildren & {
  id: string;
  label: React.ReactNode;
  labelInfo?: React.ReactNode;
  labelClassName?: string;
  name?: string;
  type?: Props['type'];
  className?: string;
};

const ToggleGroup: React.FC<ToggleGroupProps> = ({
  labelClassName,
  id,
  label,
  labelInfo,
  className,
  children
}) => (
  <>
    <label className={labelClassName} htmlFor={id}>
      {label}
      {labelInfo}
    </label>
    <div className={classNames(styles.inputWrapper, className)}>{children}</div>
  </>
);

export default ToggleGroup;
